/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceRecordWarnings
 */
export interface EvidenceRecordWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'detectedDpi'?: EvidenceRecordWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'calculatedDpi'?: EvidenceRecordWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'colorGradation'?: EvidenceRecordWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'heightMillis'?: EvidenceRecordWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecordWarnings
     */
    'widthMillis'?: EvidenceRecordWarningsWidthMillisEnum;
}

export const EvidenceRecordWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordWarningsDetectedDpiEnum = typeof EvidenceRecordWarningsDetectedDpiEnum[keyof typeof EvidenceRecordWarningsDetectedDpiEnum];
export const EvidenceRecordWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordWarningsCalculatedDpiEnum = typeof EvidenceRecordWarningsCalculatedDpiEnum[keyof typeof EvidenceRecordWarningsCalculatedDpiEnum];
export const EvidenceRecordWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceRecordWarningsColorGradationEnum = typeof EvidenceRecordWarningsColorGradationEnum[keyof typeof EvidenceRecordWarningsColorGradationEnum];
export const EvidenceRecordWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordWarningsHeightMillisEnum = typeof EvidenceRecordWarningsHeightMillisEnum[keyof typeof EvidenceRecordWarningsHeightMillisEnum];
export const EvidenceRecordWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceRecordWarningsWidthMillisEnum = typeof EvidenceRecordWarningsWidthMillisEnum[keyof typeof EvidenceRecordWarningsWidthMillisEnum];


